function stringHash(str) {
    let i, j, hash = 0x811c9dc5;
    for (i = 0, j = str.length; i < j; i++) {
        hash ^= str.charCodeAt(i);
        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return ('0000000' + (hash >>> 0).toString(16)).substring(-8);
}
export { stringHash };
